import { Client, Frame } from '@stomp/stompjs'
import SockJS from 'sockjs-client'

type WsClientOptions = {
  wsUrl: string
  token?: string | null
  debug?: (msg: string) => void
  onConnect?: () => void
  onStompError?: (frame: Frame) => void
  onWebSocketError?: (evt: Event) => void
  onWebSocketClose?: (evt: CloseEvent) => void
  onDisconnect?: () => void
  heartbeatIncoming?: number
  heartbeatOutgoing?: number
  reconnectDelay?: number
}

export const createWsClient = (opts: WsClientOptions) => {
  return new Client({
    webSocketFactory: () => new SockJS(opts.wsUrl),
    reconnectDelay: opts.reconnectDelay ?? 5000,
    heartbeatIncoming: opts.heartbeatIncoming ?? 10000,
    heartbeatOutgoing: opts.heartbeatOutgoing ?? 10000,
    connectHeaders: opts.token ? { Authorization: `Bearer ${opts.token}` } : {},
    debug: opts.debug ?? (() => {}),
    onConnect: opts.onConnect ?? (() => {}),
    onStompError: opts.onStompError ?? (() => {}),
    onWebSocketError: opts.onWebSocketError ?? (() => {}),
    onWebSocketClose: opts.onWebSocketClose ?? (() => {}),
    onDisconnect: opts.onDisconnect ?? (() => {}),
  })
}
